(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tb-billard-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    if (event.target.closest('.tb-guide')) document.querySelector('.guide_tailles_btn:not(.tb-guide)')?.click();
  });
  if (new URLSearchParams(location.search).has('tb_cloth_choice')) {
    document.querySelectorAll('.tb-cloth-notice').forEach(el => { el.hidden = false; });
  }
  } catch(e) { console.error(e); }
})();

})();
